import React from "react";
import LegalPage from "../components/LegalPage";
import { MINISTRY_SITE_URL } from "../config";

function TermsAndConditions() {
    return (
        <LegalPage
            title="Terms and Conditions"
            intro="The terms for using the CFCM Portal."
            other={{ to: "/privacy-policy", label: "Privacy Policy" }}
        >
            {/* The text of the terms goes here. */}
            <div className="cf-legal-short">
                <h2>This page is being prepared</h2>
                <p>
                    The terms and conditions for the CFCM Portal have not been published yet. If you
                    have a question in the meantime, please reach the ministry through{" "}
                    <a href={MINISTRY_SITE_URL} target="_blank" rel="noopener noreferrer">cfcm.co.ke</a>.
                </p>
            </div>
        </LegalPage>
    );
}

export default TermsAndConditions;
